"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqueHotelAreas = void 0;
const dayjs = require("dayjs");
/**
 * Get unique hotel areas and hotels with active contracts
 *
 * @param hotels - Array of hotel objects
 * @param cutoffDate - Optional date to check contract validity against (defaults to current date)
 * @returns Array of unique areas (both transfer areas and hotels themselves)
 */
const getUniqueHotelAreas = (hotels, cutoffDate = dayjs().format("YYYY-MM-DD")) => {
    // Filter hotels with active contracts
    const activeHotels = hotels.filter((hotel) => hotel.contracts
        ? hotel.contracts.filter((c) => c.end_date >= cutoffDate).length > 0
        : false);
    // Extract transfer areas from active hotels
    const uniqueAreas = activeHotels.map((hotel) => hotel.transfer_area);
    // Convert hotels themselves to Area objects
    const uniqueHotels = activeHotels.map((hotel) => ({
        id: hotel.id,
        name: hotel.name,
        type: "Hotel",
    }));
    // Combine both arrays and remove duplicates based on id
    return uniqueAreas
        .concat(uniqueHotels)
        .filter((area, index, array) => array.findIndex((item) => item.id === area.id) === index);
};
exports.getUniqueHotelAreas = getUniqueHotelAreas;
